import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, BookOpen, Sparkles } from 'lucide-react';
const comparisonData = [{
  situation: 'Un vecino te pide cambiar un enchufe',
  without: 'No sabés cuánto cobrar',
  with: 'Presupuesto PDF en 5 minutos'
}, {
  situation: 'Querés cobrar por tus servicios',
  without: 'Sin argumento profesional',
  with: 'Catálogo de 10 servicios con precios'
}, {
  situation: 'Un cliente pide garantía escrita',
  without: 'No sabés qué poner',
  with: 'Plantilla de garantía lista'
}, {
  situation: 'Querés tus primeros clientes',
  without: 'No sabés por dónde empezar',
  with: 'Plan de 7 días sin publicidad'
}, {
  situation: 'Querés ganar los fines de semana',
  without: 'Sin sistema ni precio',
  with: '$200.000-$500.000/mes adicionales'
}];
const manualIncludes = ['Los 10 servicios más rentables del mercado', 'Fórmula exacta para calcular presupuestos', 'Plan para conseguir los primeros 5 clientes en 7 días', 'Plantillas de presupuesto, garantía y contrato', 'Protocolo de atención que genera referidos automáticos', 'Contratos de mantenimiento anual recurrente', 'Plan de 90 días con hitos semanales'];
export function ComparisonTable() {
  return <section className="py-14 bg-graphite border-y border-petroleum relative overflow-hidden" data-id="element-50">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-51"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-52">
        {/* Header inside gold frame */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-53">
          <div className="absolute -inset-1 bg-gradient-to-r from-gold via-yellow-400 to-gold rounded-3xl blur-xl opacity-30 animate-pulse" data-id="element-54"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-gold rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-gold/20" data-id="element-55">
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(255,200,0,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,200,0,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-56"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-gold rounded-tl-3xl pointer-events-none" data-id="element-57"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-gold rounded-tr-3xl pointer-events-none" data-id="element-58"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-gold rounded-bl-3xl pointer-events-none" data-id="element-59"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-gold rounded-br-3xl pointer-events-none" data-id="element-60"></div>

            <div className="relative z-10" data-id="element-61">
              <div className="inline-flex items-center gap-2 bg-gold text-graphite px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-gold/40" data-id="element-62">
                <BookOpen className="w-3.5 h-3.5" data-id="element-63" />
                Manual del Emprendedor
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight" data-id="element-64">
                <span className="text-white" data-id="element-65">¿Qué agrega el </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-gold to-yellow-500 drop-shadow-[0_0_12px_rgba(255,200,0,0.4)]" data-id="element-66">
                  Manual del Electricista Emprendedor?
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-gold to-transparent opacity-70" data-id="element-67"></div>
            </div>
          </div>
        </motion.div>

        {/* Desktop comparison table */}
        <div className="max-w-5xl mx-auto mb-10 hidden md:block" data-id="element-68">
          <div className="relative bg-petroleum border border-white/10 rounded-2xl overflow-hidden shadow-xl" data-id="element-69">
            {/* Gold accent for winning column */}
            <div className="absolute top-0 bottom-0 right-0 w-1/3 bg-gradient-to-b from-gold/10 via-gold/[0.04] to-gold/10 pointer-events-none" data-id="element-70"></div>

            <table className="w-full text-left border-collapse relative" data-id="element-71">
              <thead data-id="element-72">
                <tr className="bg-graphite/70" data-id="element-73">
                  <th className="p-5 border-b border-white/10 text-textsecondary font-semibold text-xs uppercase tracking-widest w-2/5" data-id="element-74">
                    Situación real
                  </th>
                  <th className="p-5 border-b border-white/10 text-red-400 font-semibold text-xs uppercase tracking-widest" data-id="element-75">
                    <span className="inline-flex items-center gap-2" data-id="element-76">
                      <span className="w-6 h-6 rounded-md bg-red-500/15 flex items-center justify-center" data-id="element-77">
                        <X className="w-3.5 h-3.5" data-id="element-78" />
                      </span>
                      Sin el KIT
                    </span>
                  </th>
                  <th className="p-5 border-b-2 border-gold text-gold font-extrabold text-xs uppercase tracking-widest bg-gold/10 relative" data-id="element-79">
                    <span className="inline-flex items-center gap-2" data-id="element-80">
                      <span className="w-6 h-6 rounded-md bg-gold/25 flex items-center justify-center" data-id="element-81">
                        <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-82" />
                      </span>
                      Con el KIT
                      <Sparkles className="w-3.5 h-3.5 text-gold" data-id="element-83" />
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-84">
                {comparisonData.map((row, i) => <tr key={i} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02] transition-colors group" data-id="element-85">
                    <td className="p-5 text-white font-medium align-top" data-id="element-86">
                      <span className="inline-flex items-start gap-3" data-id="element-87">
                        <span className="flex-shrink-0 w-6 h-6 rounded-full bg-graphite border border-white/10 text-textsecondary text-xs font-bold flex items-center justify-center mt-0.5" data-id="element-88">
                          {i + 1}
                        </span>
                        {row.situation}
                      </span>
                    </td>
                    <td className="p-5 text-textsecondary align-top" data-id="element-89">
                      <span className="inline-flex items-start gap-2" data-id="element-90">
                        <X className="w-4 h-4 text-red-500/70 shrink-0 mt-0.5" data-id="element-91" />
                        {row.without}
                      </span>
                    </td>
                    <td className="p-5 text-white font-semibold align-top bg-gold/[0.06] group-hover:bg-gold/[0.10] transition-colors border-l border-gold/20" data-id="element-92">
                      <span className="inline-flex items-start gap-2" data-id="element-93">
                        <Check className="w-4 h-4 text-gold shrink-0 mt-0.5" strokeWidth={3} data-id="element-94" />
                        {row.with}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile comparison cards */}
        <div className="max-w-2xl mx-auto mb-10 md:hidden space-y-4" data-id="element-95">
          {comparisonData.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-petroleum border border-white/10 rounded-2xl overflow-hidden shadow-lg" data-id="element-96">
              <div className="px-5 py-3 bg-graphite/60 border-b border-white/10 flex items-center gap-2.5" data-id="element-97">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-graphite border border-white/10 text-textsecondary text-xs font-bold flex items-center justify-center" data-id="element-98">
                  {i + 1}
                </span>
                <p className="text-white font-semibold text-sm" data-id="element-99">
                  {row.situation}
                </p>
              </div>
              <div className="grid grid-cols-2 divide-x divide-white/10" data-id="element-100">
                <div className="p-4" data-id="element-101">
                  <div className="inline-flex items-center gap-1.5 text-red-400 text-[10px] font-bold uppercase tracking-wider mb-2" data-id="element-102">
                    <X className="w-3 h-3" data-id="element-103" /> Sin el KIT
                  </div>
                  <p className="text-textsecondary text-sm" data-id="element-104">{row.without}</p>
                </div>
                <div className="p-4 bg-gold/[0.06]" data-id="element-105">
                  <div className="inline-flex items-center gap-1.5 text-gold text-[10px] font-bold uppercase tracking-wider mb-2" data-id="element-106">
                    <Check className="w-3 h-3" strokeWidth={3} data-id="element-107" /> Con el KIT
                  </div>
                  <p className="text-white text-sm font-semibold" data-id="element-108">{row.with}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Includes card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto" data-id="element-109">
          <div className="absolute -inset-0.5 bg-gradient-to-r from-gold/40 via-yellow-300/30 to-gold/40 rounded-2xl blur-lg opacity-50" data-id="element-110"></div>
          <div className="relative bg-gradient-to-br from-petroleum to-graphite border border-gold/40 rounded-2xl p-8 shadow-[0_0_30px_rgba(255,200,0,0.15)]" data-id="element-111">
            <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gold/20" data-id="element-112">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-gold/30 to-gold/10 border border-gold/30 flex items-center justify-center shadow-inner" data-id="element-113">
                <BookOpen className="w-5 h-5 text-gold" data-id="element-114" />
              </div>
              <div data-id="element-115">
                <p className="text-[10px] uppercase tracking-widest text-gold font-bold" data-id="element-116">
                  Incluido en Pro
                </p>
                <h3 className="text-xl font-bold text-white leading-tight" data-id="element-117">
                  El Manual incluye:
                </h3>
              </div>
            </div>
            <div className="grid md:grid-cols-2 gap-x-6 gap-y-4" data-id="element-118">
              {manualIncludes.map((item, i) => <div key={i} className="flex items-start gap-3 group" data-id="element-119">
                  <div className="w-6 h-6 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center shrink-0 mt-0.5 group-hover:bg-gold/25 transition-colors" data-id="element-120">
                    <Check className="w-3 h-3 text-gold" strokeWidth={3} data-id="element-121" />
                  </div>
                  <span className="text-textsecondary text-sm leading-relaxed group-hover:text-white transition-colors" data-id="element-122">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}